<template>
    <div class="row">
        <div class="col">
            <div class="text-center mb-3">
                <p class="h4">
                    {{ $t("gracias.descargar_entradas") }}
                </p>
                <p>
                    {{ $t("gracias.n_pedido") }}:
                    {{ tpv_order }}
                </p>
            </div>

            <div class="text-center buttons mb-3">
                <a 
                    :href="datos_online.url_descarga"
                    class="button large-button effect-button mr-lg-2 mb-2"
                    target="_blank"
                >
                    <span style="text-transform: uppercase">
                        {{ $t("gracias.descargar_pdf_completo") }}
                    </span>
                </a>
                <router-link 
                    tag="a" 
                    :to="{ name: 'front.home' }"
                    class="button large-button effect-button mr-lg-2 mb-2"
                >
                    <span>{{ $t("gracias.volver") }}</span>
                </router-link>
            </div>
            <div class="h4 mb-3">
                Fecha: {{ sesion_fecha }}
            </div>
            <div class="h5 mb-3" v-if="datos_compradores[0].visibilidad_reducida">
                <span v-if="datos_compradores.length > 1">{{ $t("gracias.entradas_vision_reducida") }}</span>
                <span v-else>{{ $t("gracias.entrada_vision_reducida") }}</span>
            </div>
            <div>
                <template v-for="(datos_comprador, i) in datos_compradores">
                    <TarjetaEntrada 
                        v-bind:key="i"
                        :entrada="datos_comprador"
                        :index="i"
                    />
                </template>
            </div>
            <div class="mt-3">
                <template v-if="!es_dia_abonado">
                    <p>
                        <b>
                            {{ $t("gracias.duda_incidencia", { email: manager.email_incidencias ? manager.email_incidencias : "info@compralaentrada.com" }) }}
                        </b>
                    </p>
                </template>
                <template v-else>
                    <h1>
                        {{ $t("gracias.abono_activado") }}
                    </h1>
                    <b>{{ $t("gracias.recuerda") }}</b>
                    <ul>
                        <li>
                            {{ $t("gracias.una_entrada", {abonado: teatro.texto_abonado}) }}
                        </li>
                        <li>
                            {{ $t("gracias.validez_abono", {abono: teatro.texto_abono}) }}
                        </li>
                        <li>
                            {{ $t("gracias.acceso_nominativo", {abono: teatro.texto_abono}) }}
                        </li>
                        <li>
                            {{ $t("gracias.abono_personal", {abono: teatro.texto_abono}) }}
                        </li>
                        <li>
                            {{ $t("gracias.acceso") }}
                        </li>
                    </ul>
                    <p>
                        {{ $t("gracias.cuestion", { email: manager.email_incidencias ? manager.email_incidencias : "info@compralaentrada.com" }) }}
                    </p>
                </template>
            </div>
        </div>

        <SendFacebookPetition 
            v-if="pixel_id" 
            :evento_id="String(evento_id)"
            event_name="Purchase"
            :evento_name="evento_name"
            :nombre="datos_peticion.nombre"
            :apellidos="datos_peticion.apellidos" 
            :email="datos_peticion.email"
            :quantity="datos_compradores.length" 
            :total="total" 
            :url_evento="url_evento"
            :user_order="tpv_order"
            :user_id="user_id"
            :cp="datos_peticion.cp"
            :telefono="datos_peticion.telefono" 
        />
    </div>
</template>

<script>
import SendFacebookPetition from "@/components/common/SendFacebookPetition";
import TarjetaEntrada from "./components/TarjetaEntrada.vue";

export default {
    props: {
        tpv_order: {
            required: true,
            type: String
        },
        datos_online: {
            required: true,
            type: Object
        },
        datos_compradores: {
            type: Array,
            required: true
        },
        es_dia_abonado: {
            required: true,
            type: Boolean
        },
        evento_id: {
            required: true,
            type: Number
        },
        evento_name: {
            required: true,
            type: String
        },
        total: {
            required: true,
            type: Number
        },
        url_evento: {
            required: true,
            type: String
        },
        user_id: {
            required: true,
            type: Number
        },
        datos_peticion: {
            required: true,
            type: Object
        },
        sesion_fecha: {
            required: true,
            type: String
        }
    },
    data() {
        return {
            pixel_id: process.env.VUE_APP_PIXEL_ID,
        }
    },
    computed: {
        manager() {
            return this.$store.getters.getFooter;
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        teatro(){
            return this.$store.getters.getTeatro
        }            
    },
    components: {
        SendFacebookPetition, TarjetaEntrada
    }
}
</script>